import { ApplicationSummaryDto, TransactionDTO } from '@inosio/payments-sdk';
import { Card, Divider, Grid, Modal, Typography, useMediaQuery, Link as MuiLink, Box } from '@mui/material';
import { format } from 'date-fns';
import CancelIcon from '../../../icons/close.svg';

export interface ApplicationHistoryModalProps {
  open: boolean;
  onClose: () => void;
  appSummaryObj: ApplicationSummaryDto | undefined;
  clickViewReceiptCallback: (payment: TransactionDTO) => void;
}
function ApplicationHistoryModal(props: ApplicationHistoryModalProps) {
  //------Styles-----//
  const matchesMobile = useMediaQuery('(max-width:600px)');
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '16px',
    height: matchesMobile ? '100%' : '555px',
    pointerEvents: 'auto',
    width: matchesMobile ? '100%' : '520px',
    borderRadius: matchesMobile ? '0px' : '24px',
  };

  return (
    <Box>
      <Modal
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        BackdropProps={{
          invisible: false,
        }}
        disableEscapeKeyDown
      >
        <Card sx={style}>
          <Grid container width="100%" height="100%">
            <Grid item xs={12} display="Flex" justifyContent="center">
              <Typography
                sx={{
                  fontFamily: 'Work Sans',
                  fontStyle: 'normal',
                  fontWeight: 600,
                  fontSize: '18px',
                  color: '#14142B',
                }}
              >
                Application History
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                height: 400,
                overflow: 'auto',
                '&::-webkit-scrollbar': {
                  width: 7,
                },
                '&::-webkit-scrollbar-track': {
                  boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
                  borderRadius: '24px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'darkgrey',
                  borderRadius: '24px',
                },
              }}
            >
              {props.appSummaryObj?.StatusHistory?.map((status, i, row) => {
                return (
                  <Grid container key={i}>
                    <Grid item xs={12} display="Flex" justifyContent="center">
                      <Typography
                        sx={{
                          fontFamily: 'Work Sans',
                          fontStyle: 'normal',
                          fontWeight: 600,
                          fontSize: '16px',
                          color: '#14142B',
                        }}
                      >
                        {status?.Status}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} display="Flex" justifyContent="center">
                      <Typography
                        sx={{
                          fontFamily: 'Work Sans',
                          fontStyle: 'normal',
                          fontWeight: 500,
                          fontSize: '14px',
                          color: '#A8A8A8',
                        }}
                      >
                        {format(new Date(status?.Date), 'MM-dd-yyyy')}
                      </Typography>
                    </Grid>
                    {status.Status === 'Submitted' && !!status.TransactionUuid && (
                      <Grid item xs={12} display="Flex" justifyContent="center">
                        <MuiLink
                          style={{ cursor: 'pointer' }}
                          underline="hover"
                          color={'#39A2DB'}
                          onClick={() => {
                            const payment = props.appSummaryObj?.Transactions?.find((trans) => trans.TransactionUuid === status.TransactionUuid);
                            payment && props.clickViewReceiptCallback(payment);
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'Work Sans',
                              fontStyle: 'normal',
                              fontWeight: 500,
                              fontSize: '14px',
                              color: '#39A2DB',
                            }}
                          >
                            View Receipt
                          </Typography>
                        </MuiLink>
                      </Grid>
                    )}

                    <Grid item xs={12} display="Flex" justifyContent="center">
                      {i + 1 === row.length ? <></> : <Divider orientation="vertical" flexItem sx={{ height: '50px' }} />}
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
          {/* Close Icon */}
          <Grid item sx={{ position: 'absolute', top: 18, right: 20 }}>
            <img
              src={CancelIcon}
              alt="close"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                props.onClose();
              }}
            />
          </Grid>
        </Card>
      </Modal>
    </Box>
  );
}

export default ApplicationHistoryModal;
